module.exports = __webpack_public_path__ + "img/logo-light.f6c28fbe.png";